// extracted by mini-css-extract-plugin
var _1 = "XD2jBo_soLW_PfCweKfH";
var _2 = "DioGSdj6WNj7s1HVIUzG";
var _3 = "RsT9sPVyLPPnEqpXtxhQ";
var _4 = "lDXHkUBRrcYtRbVaLPgk";
var _5 = "ElnYjLIfCoW4fgLRFeOV";
var _6 = "RDWKfeJcT0h3scmMK43J";
var _7 = "j_Oo73NQI0x8B0sY4a83";
var _8 = "mXQGPfa4uYEvDNGn0qe0";
var _9 = "AnJQhcJ4A_h_x6L8lv0G";
var _a = "DOJHPJKKbVb5eEmWFvgA";
export { _1 as "color_base", _2 as "color_base_dark", _3 as "color_error", _4 as "color_main", _5 as "color_primary", _6 as "color_success", _7 as "color_success_dark", _8 as "color_warning", _9 as "color_warning_dark", _a as "color_white" }
